<header>
  <a class="marca" routerLink="/">niretxoko</a>
  <nav class="idioma" aria-label="Idioma">
    @for (i of idiomas; track i.codigo) {
      <button
        type="button"
        [class.activo]="i.codigo === lang.actual()"
        (click)="lang.usar(i.codigo)"
      >
        {{ i.codigo | uppercase }}
      </button>
    }
  </nav>
</header>
